import { createContext, useContext } from "react";

/**
 * Sample-data mode.
 *
 * Deliberately not persisted to the database and not tied to a client. It is
 * a temporary lens for learning the tools, and leaving it on by accident
 * across sessions is the one failure mode that would actually matter, so it
 * lives in sessionStorage and dies with the tab.
 */

export const DemoContext = createContext<{
  demo: boolean;
  setDemo: (v: boolean) => void;
}>({ demo: false, setDemo: () => {} });

export const useDemo = () => useContext(DemoContext);

const KEY = "analytics:demo";
export const readDemo = () => sessionStorage.getItem(KEY) === "1";
export const writeDemo = (v: boolean) => {
  if (v) sessionStorage.setItem(KEY, "1");
  else sessionStorage.removeItem(KEY);
};
